import React, { Component } from "react";

export default class EmploymentDetailFormTitle extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 20,
        }}
      >
        <h3 style={{ fontSize: 23 }}>Employment Detail Form</h3>
      </div>
    );
  }
}
